import React from 'react'

import {Box} from '@vio/atlas/src/components/designSystem/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/src/components/designSystem/SkeletonLoader'

export const DesktopAPClickerCTALoading = () => {
  return (
    <Box padding="s000">
      <Box display="flex" justifyContent="space-between">
        <div>
          <SkeletonLoader width={118} />
          <SkeletonLoader width={161} />
        </div>
        <div>
          <SkeletonLoader width={140} />
          <SkeletonLoader width={140} />
        </div>
      </Box>
    </Box>
  )
}
